
	import LoadingComponent from "custom/LoadingComponent"
	import Component from "vue-class-component"
	import IcsButton from "custom/ui/IcsButton.vue"
	import IcsInput from "custom/ui/IcsInput.vue"
	import { StoreAction } from "@lib/types/vuex"
	import { ObjectErrors } from "@lib/types/validation"
	import toaster from "custom/utils/toaster"
	import { userModule } from "store/modules"
	import { Watch } from "vue-property-decorator"
	import validate from "store/user/rules"
	import ValidationErrors from "custom/ui/ValidationErrors.vue"
	import { User } from "store/user/types"

	@Component({
		components: {
			IcsButton,
			IcsInput,
			ValidationErrors
		}
	})
	export default class MyDetails extends LoadingComponent {
		@userModule.Getter user!: User
		@userModule.Action updateCurrentUser!: StoreAction<User>

		readonly baseTranslationKey = "profile.myDetails"

		userDetails: User = {}

		errors: ObjectErrors<User> | null = null

		async submit(): Promise<void> {
			try {
				await this.manageLoadingState(this.updateCurrentUser(this.userDetails))
				toaster.success({ title: `${ this.baseTranslationKey }.success` })
			} catch (error) {
				toaster.error({ title: `${ this.baseTranslationKey }.error` })
			}
		}

		isDirty(value: any): boolean {
			return value !== undefined
		}

		@Watch("user")
		userChanged(): void {
			this.userDetails = { ...this.user }
		}

		@Watch("userDetails", { immediate: true, deep: true })
		async userDetailsChanged(user: User): Promise<void> {
			this.errors = await validate(user, undefined) || null
		}
	}
